import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { IPopupNotificationsState } from './popup-notifications.reducers';
import * as fromReducer from './popup-notifications.reducers';

const getNotificationPopupsState =
  createFeatureSelector<IPopupNotificationsState>('popupNotifications');

export const getShowAddressChangePopup = createSelector(
  getNotificationPopupsState,
  fromReducer.getShowAddressChangePopup
);
export const getShowAddressChangePopupActionState = createSelector(
  getNotificationPopupsState,
  fromReducer.getShowAddressChangePopupActionState
);
